import { notification } from 'antd'
import { getToken, customAxios as axios } from '../../../request'

import { showPageLoad, hidePageLoad } from '../../../modules/actions'
import {
  getAssessmentListUrl,
  getCallbackUrl,
  addAssessmentActivityUrl,
  getAssessmentActivityUrl,
  updateAssessmentViewedUrl,
  addNewAssessmentUrl,
  addReassessmentUrl,
  addFeedbackUrl,
  getSingleAssessmentUrl,
  notEligibleAssessmentUrl
} from '../api'


export const getAssessmentListFxn = (filters) => async (dispatch) => {
  let config = {
    params: { ...filters },
    ...getToken()
  }
  let { data } = await axios.get(getAssessmentListUrl(), config)
  return data.data
}

export const getCallbackFxn = (id) => async () => {
  let config = {
    params: {},
    ...await getToken()
  }
  let { data } = await axios.get(getCallbackUrl(id), config)
  return data.data
}
export const getAssessmentActivityFxn = (filters) => async (dispatch) => {
  let config = {
    params: { ...filters },
    ...await getToken()
  }
  let { data } = await axios.get(getAssessmentActivityUrl(), config)
  return data
}
export const addAssessmentActivityFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addAssessmentActivityUrl(), valData, getToken())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  dispatch(hidePageLoad())
  return data
}

export const updateAssessmentViewedFxn = (valData) => async (dispatch) => {
  // dispatch(showPageLoad())
  let { data } = await axios.post(updateAssessmentViewedUrl(), valData, getToken())

  dispatch(hidePageLoad())
  return data
}

export const addNewAssessmentFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addNewAssessmentUrl(), valData, getToken())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  dispatch(hidePageLoad())
  return data
}

export const addReassessmentFxn = (valData) => async (dispatch) => {
  let config = {
    ...await getToken()
  }
  let { data } = await axios.post(addReassessmentUrl(), valData, config)

  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const addFeedbackFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(addFeedbackUrl(), valData, await getToken())
  dispatch(hidePageLoad())
  if (!data.error) {
    notification.success({
      message: data.message || 'Success'
    })
  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}

export const getSingleAssessmentFxn = (valData) => async (dispatch) => {
  // dispatch(showPageLoad())
  let { data } = await axios.post(getSingleAssessmentUrl(), valData, await getToken())
  // dispatch(hidePageLoad())
  if (!data.error) {

  } else {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const notEligibleAssessmentFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad())
  let { data } = await axios.post(notEligibleAssessmentUrl(), valData, getToken())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }else{
    notification.success({
      message: data.message || 'Success'
    })
  }
  dispatch(hidePageLoad())
  return data
}
